export const InboundFilters = {
  filters: [
    {
      filterField: 'i_src_connect_type_name',
      operator: '<>',
      filterValue: 'customer'
    },
    {
      filterField: 'i_src_network_bndry_name',
      operator: '=',
      filterValue: 'external'
    },
    {
      filterField: 'i_ult_exit_connect_type_name',
      operator: '=',
      filterValue: 'customer'
    }
  ]
};

export const OutboundFilters = {
  filters: [
    {
      filterField: 'i_src_connect_type_name',
      operator: '=',
      filterValue: 'customer'
    },
    {
      filterField: 'i_ult_exit_network_bndry_name',
      operator: '=',
      filterValue: 'external'
    },
    {
      filterField: 'i_ult_exit_connect_type_name',
      operator: '<>',
      filterValue: 'customer'
    }
  ]
};

export default {
  metric: ['Traffic'],
  aggregateTypes: ['p95th_bits_per_sec'],
  lookback_seconds: 86400,
  all_devices: true,
  show_overlay: false,
  show_total_overlay: true,
  filterDimensionsEnabled: true,
  filterDimensionName: 'Total',
  filterDimensionOther: false,
  filterDimensionSort: true,
  filterDimensions: {
    connector: 'All',
    filterGroups: [
      {
        name: 'Inbound',
        named: true,
        connector: 'All',
        not: false,
        autoAdded: '',
        saved_filters: [],
        filterGroups: [],
        ...InboundFilters
      },
      {
        name: 'Outbound',
        named: true,
        connector: 'All',
        not: false,
        autoAdded: '',
        saved_filters: [],
        filterGroups: [],
        ...OutboundFilters
      }
    ]
  }
};
